import { useLanguagePreference } from '@/hooks'
import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/locales'
import { logger } from '@/ui'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { GlobeAltIcon } from '@heroicons/react/24/outline'

export function LanguageSelector() {
	const { currentLanguage, changeLanguage } = useLanguagePreference()

	return (
		<Listbox
			value={currentLanguage}
			onChange={(lang: SupportedLanguage) => {
				changeLanguage(lang).catch((error) => {
					logger.error(error, {
						category: 'language-preference',
						data: { attempted_language: lang },
					})
				})
			}}
		>
			<ListboxButton className="group flex items-center gap-1.5 px-2 py-1 rounded-md text-sm text-grey-700 hover:bg-grey-100 transition-colors cursor-pointer">
				<GlobeAltIcon className="size-5 text-grey-600" />
				<span className="hidden sm:inline">{LANGUAGE_LABELS[currentLanguage]}</span>
				<svg
					className="w-4 h-4 text-grey-400 transition-transform group-data-[open]:rotate-180"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
					strokeWidth={2}
				>
					<path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
				</svg>
			</ListboxButton>

			<ListboxOptions
				anchor="bottom end"
				transition
				className="min-w-[180px] z-[9999] bg-white rounded-lg shadow-lg border border-grey-200 py-1 [--anchor-gap:4px] origin-top transition duration-200 ease-out focus:outline-none data-closed:scale-95 data-closed:opacity-0"
			>
				{SUPPORTED_LANGUAGES.map((lang) => (
					<ListboxOption
						key={lang}
						value={lang}
						className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-grey-700 cursor-pointer transition-colors data-[focus]:bg-grey-50 data-[selected]:bg-grey-50 data-[selected]:font-medium"
					>
						<span className="truncate">{LANGUAGE_LABELS[lang]}</span>
					</ListboxOption>
				))}
			</ListboxOptions>
		</Listbox>
	)
}
